<template>
    <div id="users-index-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Users (Labs)</h1>

                <div class="table-header__controls" style="margin-bottom:10px;">
                    <div class="table-header__controls__search">
                        <SearchBox placeholder="Search" searchKey="users_index"
                            @search="updateSearchText" />
                    </div>

                    <div class="table-header__controls__show-all" v-if="showAll">
                        <a href="/users">Show less</a>
                    </div>
                    <div class="table-header__controls__show-all" v-else>
                        <a href="/users?showAll=1">Show all</a>
                    </div>
                </div>

                <DataTable class="users-data-table"
                        :dataUrl="dataUrl"
                        :displayId="false"
                        :key="tableRefreshKey"
                        :dataFormatter="formatData"
                        :sortable="true"
                        @actionTriggered="actionTriggered"
                        :filterText="searchQuery">

                    <template v-slot:empty>
                        No records found
                    </template>
                </DataTable>
            </section>
        </div>

        <ManageLibrariesModal v-if="activeLibrariesUserId"
            :userId="activeLibrariesUserId"
            :libraries="activeLibraries"
            @modalClosed="librariesModalClosed" />

        <DevicesModal v-if="activeDevicesUserId"
            :userId="activeDevicesUserId"
            :devices="activeDevices"
            @modalClosed="devicesModalClosed" />

        <CommentsModal v-if="activeCommentsUserId"
                      :userId="activeCommentsUserId"
                      @modalClosed="commentsModalClosed" />

    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'
import SearchBox from '@/components/global/SearchBox.vue'

import ManageLibrariesModal from '@/components/global/ManageLibrariesModal.vue'
import DevicesModal from '@/components/global/DevicesModal.vue'
import CommentsModal from "@/components/global/CommentsModal.vue";

import axios from 'axios'
const endpoint = process.env.VUE_APP_API_BASE + '/users'

export default {
    name: 'UsersIndex',
    components: {
        CommentsModal,
        DataTable,
        SearchBox,
        ManageLibrariesModal,
        DevicesModal
    },
    data: function() {
        return {
            //users: [],
            dataUrl: endpoint,
            tableRefreshKey: null,

            activeLibraries: [],
            activeLibrariesUserId: null,

            activeDevices: [],
            activeDevicesUserId: null,

            activeCommentsUserId: null,
            activeCommentsNum: null,

            searchQuery: ''
        }
    },
    computed: {
        showAll() {
            const searchParams = new URLSearchParams(window.location.search);
            return searchParams.has('showAll')
        }
    },
    methods: {
        updateSearchText(query) {
            this.searchQuery = query
        },
        librariesModalClosed(save = false) {
            this.activeLibrariesUserId = null
            this.activeLibraries = []

            if (save === true) {
                this.tableRefreshKey = Date.now()
            }
        },
        devicesModalClosed() {
            this.activeDevicesUserId = null
            this.activeDevices = []
        },
        commentsModalClosed(commentsNum) {
            this.activeCommentsUserId = null
            if (commentsNum !== this.activeCommentsNum) {
                this.tableRefreshKey = Date.now()
            }
            this.activeCommentsNum = null
        },
        truncateString(str, length) {
            if (str.length <= length) {
                return str
            }
            return '<span title="' + str + '">' + str.substring(0, length) + '..' + '</span>'
        },
        formatData(data) {
            const newData = []
            for (let obj of data) {
                const newObj = {}
                //const ignore = ['__v', 'address', 'website', 'isEnabled', 'createdAt', 'updatedAt']
                const columns = ['_id', 'name', 'libraries', 'email', 'country', 'contact', 'devices', 'lastConnect', 'lastVersion', 'comments', 'agent', 'createdAt']

                for (let key of columns) {

                    if (key === 'libraries') {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'libraries'
                        }
                    }
                    else if (key === 'devices') {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'devices'
                        }
                    }
                    else if (key === 'country') {
                        const state = obj['state'] ? obj['state'] + ', ' : ''
                        let myValue = this.truncateString(obj[key]['code'] + ', ' + state + obj['city'], 22)

                        newObj[key] = {
                            'label': key,
                            'value': '<img style="vertical-align: middle;" src="https://flagsapi.com/' + obj[key]['code'] + '/shiny/64.png" width="22" />' + ' <span style="vertical-align: middle;">' + myValue + '</span>',
                            'display_type': 'html'
                        }
                    }
                    else if (key === 'contact') {
                        newObj[key] = {
                            'label': key,
                            'value': { 'Owner Name': obj['ownerName'], 'Lab Phone': obj['phone'] , ...obj[key] },
                            'display_type': 'object'
                        }
                    }
                    else if (key === 'name') {
                        let theName = this.truncateString(obj[key], 22)

                        const currentDate = new Date()
                        let myValue = `<svg width="10" height="10" xmlns="http://www.w3.org/2000/svg">
  <ellipse style="fill:green; stroke:none" cx="5" cy="5" rx="5" ry="5"></ellipse>
  </svg>&nbsp;&nbsp;` + theName

                        if (obj['isEnabled'] === false) {
                            myValue = `<svg width="10" height="10" xmlns="http://www.w3.org/2000/svg">
    <ellipse style="fill:red; stroke:none" cx="5" cy="5" rx="5" ry="5"></ellipse>
    </svg>&nbsp;&nbsp;` + theName
                        }
                        else if (!obj['lastConnect'] || new Date(obj['lastConnect']) < new Date().setMonth(currentDate.getMonth() - 1)) {
                            myValue = `<svg width="10" height="10" xmlns="http://www.w3.org/2000/svg">
    <ellipse style="fill:orange; stroke:none" cx="5" cy="5" rx="5" ry="5"></ellipse>
    </svg>&nbsp;&nbsp;` + theName
                        }

                        newObj[key] = {
                            'label': key,
                            'value': myValue,
                            'display_type': 'html'
                        }
                    }
                    else if (key.includes('At') || key === 'lastConnect') {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'date'
                        }
                    }
                    else if (key === 'agent') {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key]?.name,
                            'display_type': 'text'
                        }
                    }
                    else if (key === 'comments') {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'hidden'
                        }
                    }
                    else {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'text'
                        }
                    }
                }

                if (obj['referralNote']) {
                    newObj['referralNote'] = {
                        'label': 'referral note',
                        'value': obj['referralNote'],
                        'display_type': 'hidden'
                    }
                }


                let actions = {}

                if (obj['referralNote'] && obj['referralNote'].length) {
                    actions['referralNote'] = `<i class="referral-note-action" title="${obj['referralNote']}" style="vertical-align: middle;">
<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width="18px" height="18px"><path d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 25 11 A 3 3 0 0 0 22 14 A 3 3 0 0 0 25 17 A 3 3 0 0 0 28 14 A 3 3 0 0 0 25 11 z M 21 21 L 21 23 L 22 23 L 23 23 L 23 36 L 22 36 L 21 36 L 21 38 L 22 38 L 23 38 L 27 38 L 28 38 L 29 38 L 29 36 L 28 36 L 27 36 L 27 21 L 26 21 L 22 21 L 21 21 z"/></svg>
</i>`
                }

                actions['comments'] = `<i class="comments-action" style="vertical-align: middle;">
<svg width="18px" height="18px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">
    <desc>Created with Sketch Beta.</desc>
    <defs></defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
        <g id="Icon-Set" sketch:type="MSLayerGroup" transform="translate(-360.000000, -255.000000)" fill="#000000">
            <path d="M390,277 C390,278.463 388.473,280 387,280 L379,280 L376,284 L373,280 L365,280 C363.527,280 362,278.463 362,277 L362,260 C362,258.537 363.527,257 365,257 L387,257 C388.473,257 390,258.537 390,260 L390,277 L390,277 Z M386.667,255 L365.333,255 C362.388,255 360,257.371 360,260.297 L360,277.187 C360,280.111 362.055,282 365,282 L371.639,282 L376,287.001 L380.361,282 L387,282 C389.945,282 392,280.111 392,277.187 L392,260.297 C392,257.371 389.612,255 386.667,255 L386.667,255 Z" id="comment-5" sketch:type="MSShapeGroup">

</path>
        </g>
    </g>
</svg>
${obj['comments'] && obj['comments'].length ? obj['comments'].length : 0}</i>`

                actions['edit'] = `<i class="edit-user-action" title="Edit">Edit</i>`
                actions['delete'] = `<i class="delete-user-action" title="Delete">Delete</i>`

                newObj['actions'] = {
                    'label': '',
                    'value': actions,
                    'display_type': 'actions'
                }

                //const newObjOrdered = Object.assign({'image': ''}, newObj)
                if (this.showAll || obj['country']['code'] !== 'IL') {
                    newData.push(newObj)
                }
            }
            return newData
        },
        actionTriggered(actionKey, identifier, obj) {
            if (!identifier) {
                alert('Error occurred #89')
            }
            else if (actionKey == 'edit') {
                this.$router.push('/users/' + identifier)
            }
            else if (actionKey == 'delete') {
                if (confirm('Are you sure you want to delete this user?')) {
                    axios.delete(endpoint + '/' + identifier)
                        .then(response => {
                            if (response.data.success === true) {
                                this.tableRefreshKey = Date.now()
                            }
                            else {
                              alert('Error occurred')
                              console.log(response.data.data)
                            }
                        })
                        .catch(error => {
                            alert('Error occurred while deleting')
                            console.log(error)
                        })
                }
            }
            else if (actionKey === 'libraries') {
                this.activeLibraries = obj['libraries']['value']
                this.activeLibrariesUserId = identifier
            }
            else if (actionKey === 'devices') {
                this.activeDevices = obj['devices']['value']
                this.activeDevicesUserId = identifier
            }
            else if (actionKey === 'comments') {
                this.activeCommentsUserId = identifier
                this.activeCommentsNum = obj['comments']?.value?.length ?? 0
                //this.$router.push('/users/' + identifier + '?comments=1')
            }
            else if (actionKey === 'referralNote') {
                alert(obj['referralNote']?.value)
            }
        }
    }
}
</script>

<style lang="scss">
.dt-action-referralNote, .dt-action-comments {
    a {
        text-decoration: none;
    }
}
.table-header__controls__show-all {
    float: right;
    margin-top: 10px;
}

@media screen and (max-width: 500px) {
    .table-header__controls__show-all {
        float: none;
    }
}
</style>
